module.exports = __webpack_public_path__ + "img/dt.559452f.svg";